/**
 * Tab segments of the domain. Order follows the feature: Night work for minors (US 164) is inserted before
 * Break hours for minors when it is delivered.
 */
export enum ContractComplianceTab {
  NIGHT_WORK_FOR_MINORS = 'night-work-for-minors',
  BREAK_HOURS_FOR_MINORS = 'break-hours-for-minors',
}

export const DEFAULT_CONTRACT_COMPLIANCE_TAB = ContractComplianceTab.NIGHT_WORK_FOR_MINORS;
